<template>
<div v-if="showBlock" class="pagelinks__container" ref="pagelinks">
    <h3 class="pagelinks__title h-32 h-m-22 fw-semi">Не нашли нужную информацию?</h3>
    <div class="pagelinks__wrapper">
        <template v-for="(link, idx) in items" :key="idx">
            <a class="pagelinks__link" @click="metrika(link.title)" :href="link.url" :title="link.title"
                :target="link.blank === 'Y' ? `newWindow${idx}` : ''">
                <span>{{ link.title }}</span>
            </a>
        </template>
        <a class="pagelinks__link" :href="search_btn.url" @click="metrika(search_btn.title)" :title="search_btn.title"
            :target="search_btn.blank === 'Y' ? 'searchBtn' : ''">
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M9.90741 5.33333C7.65736 5.33333 5.83333 7.15736 5.83333 9.40741C5.83333 11.6575 7.65736 13.4815 9.90741 13.4815C11.0031 13.4815 11.9978 13.0489 12.73 12.3453C12.7466 12.3241 12.7646 12.3037 12.7842 12.2842C12.8037 12.2646 12.8241 12.2466 12.8453 12.23C13.5489 11.4978 13.9815 10.5031 13.9815 9.40741C13.9815 7.15736 12.1575 5.33333 9.90741 5.33333ZM14.1734 12.7306C14.8887 11.8138 15.3148 10.6603 15.3148 9.40741C15.3148 6.42098 12.8938 4 9.90741 4C6.92098 4 4.5 6.42098 4.5 9.40741C4.5 12.3938 6.92098 14.8148 9.90741 14.8148C11.1603 14.8148 12.3138 14.3887 13.2306 13.6734L15.3619 15.8047C15.6223 16.0651 16.0444 16.0651 16.3047 15.8047C16.5651 15.5444 16.5651 15.1223 16.3047 14.8619L14.1734 12.7306Z"
                    fill="#252628" />
            </svg>
            {{ search_btn.title }}
        </a>
    </div>

</div>
</template>

<script>
export default {
    name: 'PageLinks',
    props: ['items'],
    data() {
        return {
            search_btn: {
                title: 'Поиск',
                url: '/search/',
                blank: 'N'
            },
            href: ''
        }
    },
    mounted(){
      this.href = window.location.href
    },
    computed: {
        showBlock() {
            return this.items?.length > 0;
        }
    },
    methods: {
      metrika(item){
        let obj = {
          MoreInfo:
              {
                TabName: {}
              }
        }

        obj['MoreInfo']['TabName'][item] = {URL: this.href}
        yaCounter50230510.reachGoal('moreinfo-click-tab', obj);
      }
    },
}
</script>